import { render, staticRenderFns } from "./TreeKnowledgeShow.vue?vue&type=template&id=8de14ad4&scoped=true&"
import script from "./TreeKnowledgeShow.vue?vue&type=script&lang=ts&"
export * from "./TreeKnowledgeShow.vue?vue&type=script&lang=ts&"
import style0 from "./TreeKnowledgeShow.vue?vue&type=style&index=0&id=8de14ad4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de14ad4",
  null
  
)

export default component.exports